module.exports = __webpack_public_path__ + "img/26452E0D3010D28E3FF655400C974145.26452e0d.png";